<template>
  <div id="app" :class="skinName">
    <router-view />
  </div>
</template>
<script>
  // import { useMsgServer } from 'middle-domain';
  import appMixin from '@/app-shared/mixins/appMixin.js';
  export default {
    name: 'App',
    mixins: [appMixin],
    computed: {
      skinName() {
        return window.$globalConfig.currentSkin;
      }
    },
    methods: {
      // beforeunloadHandler(event) {
      //   // 主动调用离开
      //   this.msgServer?.destroy(0);
      // }
    },
    beforeCreate() {
      // this.msgServer = useMsgServer();
    },
    mounted() {
      // 监听浏览器tab刷新或关闭事件
      // window.addEventListener('beforeunload', this.beforeunloadHandler);
    },

    beforeDestroy() {
      // window.removeEventListener('beforeunload', this.beforeunloadHandler);
    }
  };
</script>
